import getErrorMessage from "../utils/getErrorMessage";

const Common = (app) => {
  app
    .post("/common/refresh", async ({ res }) => {
      res.backDontScroll();
    })
    .post("/common/toast", async ({ req, res, flash }) => {
      const { body } = req;
      const { type, message } = body;
      flash(type, message);
      res.backDontScroll();
    })
    .get("/common/check-modified", async ({ res, api, locals, flash }) => {
      try {
        const userId = locals.activeUser?._id;
        const response = await api("modified", { query: { user: userId } });
        const modified = await response.json();
        res.status = 200;
        res.body = modified;
      } catch (error) {
        flash("error", getErrorMessage(error));
        res.backDontScroll();
      }
    });
};

export default Common;
